import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

import { withRouter } from 'react-router-dom';
import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import { find } from 'lodash';

import { getAccountDetails } from '../../store/selectors/account';
import BookingCard from '../../components/bookings/BookingCard';
import closeIcon from '../../assets/images/close.svg';
import {
  getUpcomingBookings,
  getBookingHistoryByMonth,
  getInProgressBookings
} from '../../store/selectors/bookings';
import BookingHistoryList from '../../components/bookings/BookingHistoryList';
import AsyncContent from '../../components/shared/AsyncContent';
import { fetchAllClosedRentals } from '../../store/actions/rentals';

import config from '../../config';
import {
  closedStatuses,
  inProgressStatuses,
  upcomingStatuses
} from './../../utils/rentalStatuses';

const BookingsHistory = ({ history }) => {
  const [page, setPage] = useState(1);
  const { t } = useTranslation(['account']);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const tenant = useSelector(state => state.tenant);
  const accountDetails = useSelector(getAccountDetails(tenant.dateFormat));
  const upcomingBookings = useSelector(getUpcomingBookings);
  const inProgressBookings = useSelector(getInProgressBookings);
  const bookingHistory = useSelector(getBookingHistoryByMonth);
  const vehicles = useSelector(state => state.vehicles.list);
  const pageCount = useSelector(state =>
    Math.ceil(state.rentals.closedMeta.total / state.rentals.closedMeta.limit)
  );

  const handlePageChange = async (event, value) => {
    setPage(value);
    await dispatch(fetchAllClosedRentals(value, accountDetails.id));
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      await dispatch(fetchAllClosedRentals(page, accountDetails.id));
      setIsLoading(false);
    };

    loadData();
  }, []);

  const handleBookingClick = id => {
    history.push(`${config.auth.rootUrl}account/bookings-history/${id}`);
  };

  const handleReturn = () => {
    history.push(config.auth.rootUrl);
  };

  return (
    <div className="bookings-page">
      <Container
        maxWidth="md"
        className="account-page-container future-bookings-container"
      >
        <div className="page-header">
          <Typography component="h1">
            {t('account:bookings-history')}
          </Typography>

          <div className="close-button">
            <IconButton onClick={handleReturn}>
              <img src={closeIcon} alt="" width="30" height="30" />
            </IconButton>
          </div>
        </div>
      </Container>

      <div className="white-background past-bookings">
        <Container maxWidth="md" className="account-page-container">
          <AsyncContent loading={isLoading}>
            {typeof bookingHistory === 'object' &&
            Object.keys(bookingHistory).length ? (
              <BookingHistoryList
                historyByMonth={bookingHistory}
                vehicles={vehicles}
              />
            ) : (
              <div className="no-booking">{t('account:no-booking')}</div>
            )}
          </AsyncContent>

          <div className="pagination">
            <Pagination
              margin="normal"
              defaultPage={1}
              siblingCount={1}
              boundaryCount={2}
              shape="rounded"
              count={pageCount}
              page={page}
              onChange={handlePageChange}
            />
          </div>
        </Container>
      </div>
    </div>
  );
};

export default withRouter(BookingsHistory);
